// extracted by mini-css-extract-plugin
export var askAiIcon = "_qv-9";
export var container = "_qv-0";
export var groupSeparator = "_qv-a";
export var highlight = "_qv-4";
export var resultIcon = "_qv-5";
export var resultItem = "_qv-7";
export var resultSubtitle = "_qv-3";
export var resultTitle = "_qv-2";
export var resultsList = "_qv-1";
export var searchGroup = "_qv-6";
export var selected = "_qv-8";